<div class="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h2 *ngIf="!hasError">Import RdSAP Data</h2>
        <h2 *ngIf="hasError">Invalid RdSAP File</h2>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cancel()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div *ngIf="!hasError">
          <input type="file" id="file-upload" (change)="onFileSelected($event)" accept=".xml" hidden />
          <label for="file-upload" *ngIf="uploader.queue.length === 0">
            <i class="bi bi-cloud-upload"></i> Select .xml file to upload
          </label>
        </div>
        <div *ngIf="hasData">
          <table class="table table-responsive vertically-middle">
            <tbody>
              <tr><td>Certification Date</td><td>{{vm.RdSAPDetails.certificationDate | date:'dd/MM/yyyy'}}</td></tr>
              <tr><td>RRN</td><td>{{vm.RdSAPDetails.rrn}}</td></tr>
              <tr><td>Assessor</td><td>{{vm.RdSAPDetails.assessor}}</td></tr>
              <tr><td>Assessor ID</td><td>{{vm.RdSAPDetails.assessorId}}</td></tr>
              <tr><td>RdSAP Version</td><td>{{vm.RdSAPDetails.rdSAPVersion}}</td></tr>
            </tbody>
          </table>
          <div class="padding-top-24">
            <table class="table table-responsive vertically-middle">
              <tbody>
                <tr><td>SAP Rating</td><td><rdsap-band type="chip-medium" rating="vm.RdSAPDetails.sapRating"></rdsap-band></td></tr>
                <tr><td>Potential SAP Rating</td><td><rdsap-band type="chip-medium" rating="vm.RdSAPDetails.potentialSAPRating"></rdsap-band></td></tr>
                <tr><td>Current CO₂ Emissions</td><td>{{vm.RdSAPDetails.cO2EmissionCurrent}} tonnes</td></tr>
                <tr><td>Potential CO₂ Emissions</td><td>{{vm.RdSAPDetails.cO2EmissionPotential}} tonnes</td></tr>
                <tr><td>Space Heating Demand</td><td>{{vm.RdSAPDetails.spaceHeatingDemand}} kWh</td></tr>
                <tr><td>Water Heating Demand</td><td>{{vm.RdSAPDetails.waterHeatingDemand}} kWh</td></tr>
                <tr><td>Current Primary Energy Use</td><td>{{vm.RdSAPDetails.primaryEnergyUseCurrent}} kWh/m²</td></tr>
                <tr><td>Potential Primary Energy Use</td><td>{{vm.RdSAPDetails.primaryEnergyUsePotential}} kWh/m²</td></tr>
                <tr><td>Total Floor area</td><td>{{vm.RdSAPDetails.totalFloorArea}} m²</td></tr>
                <tr><td>Heat Demand /m₂</td><td>{{vm.RdSAPDetails.heatDemandPerSquareMeter}} kWh/m²</td></tr>
              </tbody>
            </table>
          </div>
       </div>
       <div *ngIf="hasError">
          <h2><i class="icon icon-alert-circle s16 red-fg"></i> Validation Error</h2>
          <div class="error-message">{{error}}</div>
        </div>
      </div>
      <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="cancel()">Cancel</button>
          <button type="button" (click)="save()" [disabled]="!hasData" *ngIf="!hasError"><span>Import</span></button>
      </div>
    </div>
  </div>
</div>
